// extracted by mini-css-extract-plugin
module.exports = {"section":"auth-partner-portal-layout_section__07KL5","bg":"auth-partner-portal-layout_bg__N8Ek9"};